import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Nav from "../components/site/Nav";
import Footer from "../components/site/Footer";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Listings from "../components/site/Listings";
import Contact from "../components/site/Contact";
import { AreaMarquee, Services, Testimonials, SoldShowcase } from "../components/site/Extras";
import BuyerGuide from "../components/site/BuyerGuide";
import MortgageSection from "../components/site/MortgageSection";
import BrokerQuote from "../components/site/BrokerQuote";

export default function Home() {
  const [profile, setProfile] = useState(null);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data));
    api.get("/testimonials").then((r) => setTestimonials(r.data));
  }, []);

  return (
    <div className="bg-[#FAF9F6]">
      <Nav name={profile?.name} logo={profile?.logo} />
      <Hero profile={profile} />
      <AreaMarquee areas={profile?.service_areas} />
      <BrokerQuote />
      <About profile={profile} />
      <Listings />
      <SoldShowcase />
      <Services services={profile?.services || []} />
      <MortgageSection />
      <Testimonials testimonials={testimonials} />
      <BuyerGuide />
      <Contact profile={profile} />
      <Footer profile={profile} />
    </div>
  );
}
